import { Box, Grommet, Layer, ThemeType } from "grommet";
import { useContext, useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useImmer } from 'use-immer';
import "./App.css";
import { LoadingIndicator } from "./components/LoadingIndicator";
import { NewReport } from "./components/NewReport";
import { RealmContext } from "./components/providers/RealmContext";
import {
  RealmProvider,
} from "./components/providers/RealmProvider";
import { ClientWrapper } from "./components/wrappers/ClientWrapper";
// import defaultTheme from './theme.json';
import { theme as defaultTheme } from "./theme";

function App() {
  const [theme, setTheme] = useImmer<ThemeType>(defaultTheme);
  useEffect(() => {
    // console.log('theme update');
    setTheme(defaultTheme);
  }, [defaultTheme]);

  return (
    <Grommet full theme={theme}>
      <BrowserRouter>
        <RealmProvider id={'cleandns-client-abuse-form'} remember={false} anon={true}>
          <RealmProvider.LoggedOut>
            <AutoLogin />
          </RealmProvider.LoggedOut>
          <RealmProvider.LoggedIn>
            <Routes>
              <Route path=":client" element={<ClientWrapper setTheme={setTheme} />}>
                <Route index element={<NewReport />} />
                <Route path=":type" element={<NewReport />} />
              </Route>
              <Route path="/" element={<Navigate to="/cleandns" replace />} />
            </Routes>
          </RealmProvider.LoggedIn>
        </RealmProvider>
      </BrowserRouter>
    </Grommet>
  );
}

export default App;

function AutoLogin() {
  const { isLoggedIn, login } = useContext(RealmContext);
  const [ waiting, setWaiting ] = useState(true);
  const [ newUrl, setNewUrl ] = useState<string>('');
  
  useEffect(() => {
    function redirect() {
      if (window.location.origin === 'https://abuse.sav.com') {
        window.location.replace('https://abuse.cleandns.space/sav');
      }
      else if (window.location.origin === 'https://abuse.nominet.uk') {
        // window.location.replace('https://abuse.cleandns.space/nominet');
      }
      else if (window.parent && window.parent !== window && window.location.href.startsWith('https://abuse.cleandns.space/')) {
        setNewUrl(window.location.href);
        setWaiting(false);
        window.parent.location.replace(window.location.href);
      }
      else if (window.parent && window.parent !== window && window.location.href.startsWith('https://abuse.cleandns.app/')) {
        setNewUrl(window.location.href);
        setWaiting(false);
        window.parent.location.replace(window.location.href);
      }
    }

    const timer = setTimeout(redirect, 2500);

    if (!isLoggedIn) {
      login('anonymous').catch(() => {
        redirect();
      })
    }

    return () => {
      clearTimeout(timer);
    }
  }, [isLoggedIn, login]);

  if (waiting) {
    return <LoadingIndicator />;
  }
  else {
    return <Layer modal={true}>
      <Box pad="medium" gap="medium" align="center">
        <div>If the form is not loading, <a target="_parent" href={newUrl}>use this link to continue</a></div>
      </Box>
    </Layer>
  }
}
